import angular from 'angular';
import DobDMYCtrl from './dobDMYCtrl';
import dob from './dobDMY';
import './style.scss';

export default angular
  .module('components.dob', [])
  .controller('DobDMYCtrl', DobDMYCtrl)
  .component('dob', dob).name;
